module.exports = __webpack_public_path__ + "4d6371a7aa5fe93d2ded5662c3661254.jpg";